export const occupation = [
  'UNDERGRADUATE',
  'GRADUATE',
  'EXCHANGE',
  'EDUCATION',
  'IT_SOFTWARE_ENGINEERING',
  'MANUFACTURE_AGRICULTURE',
  'ARTS_DESIGN',
  'FINANCE_BANKING',
  'PUBLIC_SERVICE',
  'HEALTHCARE_MEDICAL',
  'BUSINESS_SALES',
  'LEGAL_CONSULTING',
  'OTHERS',
] as const;

export const occupationMap = {
  UNDERGRADUATE: 'Undergraduate Student',
  GRADUATE: 'Graduate Student',
  EXCHANGE: 'Exchange Student',
  EDUCATION: 'Education/Academic Research',
  IT_SOFTWARE_ENGINEERING: 'IT/Software/Engineering',
  MANUFACTURE_AGRICULTURE: 'Manufacture/Agriculture',
  ARTS_DESIGN: 'Arts/Design',
  FINANCE_BANKING: 'Finance/Banking',
  PUBLIC_SERVICE: 'Public Service/Government',
  HEALTHCARE_MEDICAL: 'Healthcare/Medical Service',
  BUSINESS_SALES: 'Business/Sales',
  LEGAL_CONSULTING: 'Legal/Consulting',
  OTHERS: 'Others',
};
